import cn from "classnames";
import { DefaultTemplate } from "components/modal/templates";
import Loader from "components/shared/loader";
import { dateTimeToView, humanizedTimeRange } from "helpers/date";
import React, { Fragment } from "react";
import { setItemChangePointDates } from "sources/books/bids";

export default class ChangePointVisit extends DefaultTemplate {
    state = {
        activeItemIndex: null,
        loading: false,
    };

    saveVisitItem = () => {
        if (this.state.activeItemIndex === null) {
            return;
        }
        const { id, bidId, visits } = this.props;
        const { enterDate, leaveDate } = visits[this.state.activeItemIndex];
        const reqData = {
            id,
            bidId,
            manualStartAt: enterDate || null,
            manualEndAt: leaveDate || null,
        };
        this.setState({ isLoading: true });
        return setItemChangePointDates(reqData).then(() => {
            this.setState({ isLoading: false });
            this.close(true);
        });
    };

    renderVisitItem = ({ isMobile, duration, enterDate, leaveDate }, i) => {
        const cname = cn("b-visit__tr", {
            "b-visit__tr--active": this.state.activeItemIndex === i,
        });
        return (
            <div key={i} className={cname} onClick={() => this.setState({ activeItemIndex: i })}>
                <div className="b-visit__td b-visit__td--checkbox">
                    <div className="b-visit__checkbox" />
                </div>
                <div className="b-visit__td">{dateTimeToView(enterDate)}</div>
                <div className="b-visit__td">{dateTimeToView(leaveDate)}</div>
                <div className="b-visit__td">{humanizedTimeRange(duration)}</div>
                <div className="b-visit__td">{isMobile ? "Телефон" : "Трекер"}</div>
            </div>
        );
    };

    renderBody = () => {
        if (this.state.loading) {
            return <Loader />;
        }
        const btnCname = cn("btn btn-brand btn-sm", { disabled: this.state.activeItemIndex === null });
        if (this.props.visits.length === 0) {
            return <h5 className="text-center text-muted pb-4">Нет данных о посещении данной точки</h5>;
        }
        return (
            <Fragment>
                <div className="b-visit">
                    <div className="b-visit__list">
                        <div className="b-visit__tr bg-secondary">
                            <div className="b-visit__td b-visit__td--checkbox" />
                            <div className="b-visit__td">Время въезда</div>
                            <div className="b-visit__td">Время выезда</div>
                            <div className="b-visit__td">Продолжительность</div>
                            <div className="b-visit__td">Источник данных</div>
                        </div>
                        {this.props.visits.map(this.renderVisitItem)}
                    </div>
                </div>
                <div className="b-visit__footer">
                    <div className="btn btn-secondary btn-sm mr-2" onClick={this.close.bind(this, false)}>
                        Отменить
                    </div>
                    <div className={btnCname} onClick={this.saveVisitItem}>
                        Сохранить
                    </div>
                </div>
            </Fragment>
        );
    };
}
